export interface Product {
  id: number;
  name: string;
  category: string;
  code: string;
  power: string;
  colorTemp: string;
  ipRating: string;
  description: string;
  features: string[];
  image: string;
  badge?: string;
}

export const productCategories = [
  'Tümü',
  'Dış Cephe Armatürleri',
  'İç Mekan LED',
  'Endüstriyel High-Bay',
  'Mimari Aydınlatma',
  'Akıllı LED Sistemler',
  'Sokak & Yol LED',
];

export const allProducts: Product[] = [
  {
    id: 1,
    name: 'Cephe Pro X500',
    category: 'Dış Cephe Armatürleri',
    code: 'OKY-FP-X500',
    power: '50W / 100W / 150W',
    colorTemp: '2700K – 6500K',
    ipRating: 'IP67',
    description: 'Bina dış cephe aydınlatması için tasarlanmış yüksek performanslı LED armatür. Alüminyum gövde, temperli cam.',
    features: ['IP67 su geçirmezlik', 'DMX512 kontrol', 'Anti-UV kaplama', 'Uzun ömürlü CREE LED çip'],
    image: 'https://readdy.ai/api/search-image?query=professional%20LED%20architectural%20wall%20washer%20flood%20light%20fixture%20modern%20sleek%20design%20white%20light%20aluminum%20housing%20clean%20minimalist%20product%20photography%20white%20background%20high%20quality&width=600&height=500&seq=prod1&orientation=squarish',
    badge: 'En Çok Satan',
  },
  {
    id: 2,
    name: 'LinearLine 1200',
    category: 'Mimari Aydınlatma',
    code: 'OKY-LL-1200',
    power: '36W / 48W',
    colorTemp: '3000K – 4000K',
    ipRating: 'IP54',
    description: 'Mimari çizgileri vurgulamak için geliştirilen ince profil LED lineer armatür. Alçıpan ve beton uyumlu.',
    features: ['Sürekli ışık hattı', 'Triac dim desteği', 'Renk bütünlüğü CRI 95+', '5 yıl garanti'],
    image: 'https://readdy.ai/api/search-image?query=modern%20LED%20linear%20strip%20light%20architectural%20recessed%20lighting%20slim%20profile%20aluminum%20clean%20design%20product%20shot%20white%20background%20professional%20studio%20photography%20minimalist&width=600&height=500&seq=prod2&orientation=squarish',
    badge: 'Yeni',
  },
  {
    id: 3,
    name: 'HighBay Master 200',
    category: 'Endüstriyel High-Bay',
    code: 'OKY-HB-200',
    power: '100W / 150W / 200W',
    colorTemp: '5000K / 5700K',
    ipRating: 'IP65',
    description: 'Yüksek tavanlı fabrika, depo ve spor salonu uygulamaları için optimize edilmiş LED high-bay armatür.',
    features: ['MH 400W muadili', '150 lm/W verimlilik', 'Sensör bağlantısı', 'DALI protokol desteği'],
    image: 'https://readdy.ai/api/search-image?query=industrial%20LED%20high%20bay%20light%20fixture%20UFO%20shape%20modern%20aluminum%20design%20energy%20efficient%20warehouse%20lighting%20product%20photography%20white%20clean%20background%20professional&width=600&height=500&seq=prod3&orientation=squarish',
    badge: 'Endüstriyel',
  },
  {
    id: 4,
    name: 'SmartRGBW Controller',
    category: 'Akıllı LED Sistemler',
    code: 'OKY-SC-RGBW',
    power: '—',
    colorTemp: 'RGBW / Tunable White',
    ipRating: 'IP20',
    description: 'Tüm OKAYISU RGBW armatürlerle uyumlu, WiFi + DMX destekli akıllı kontrol ünitesi. Sahne programlama özellikli.',
    features: ['Wi-Fi & DMX512', 'Uygulama kontrolü', '512 zon yönetimi', 'Sahne hafızası'],
    image: 'https://readdy.ai/api/search-image?query=smart%20LED%20controller%20unit%20RGB%20lighting%20control%20system%20modern%20electronic%20device%20clean%20white%20design%20product%20photography%20studio%20white%20background%20professional%20minimalist&width=600&height=500&seq=prod4&orientation=squarish',
  },
  {
    id: 5,
    name: 'StreetPro E80',
    category: 'Sokak & Yol LED',
    code: 'OKY-SP-E80',
    power: '60W / 80W / 100W',
    colorTemp: '4000K / 5700K',
    ipRating: 'IP66 / IK10',
    description: 'Şehir içi ve şehir dışı yol aydınlatması için yüksek performanslı LED sokak armatürü. Titanyum gri renk.',
    features: ['IK10 darbe dayanımı', 'Asimetrik optik', '100.000 saat ömür', 'NEMA soket bağlantısı'],
    image: 'https://readdy.ai/api/search-image?query=modern%20LED%20street%20light%20pole%20lamp%20outdoor%20road%20lighting%20fixture%20aluminum%20design%20clean%20white%20background%20product%20photography%20professional%20studio%20shot%20energy%20efficient&width=600&height=500&seq=prod5&orientation=squarish',
    badge: 'Kamu Sektörü',
  },
  {
    id: 6,
    name: 'PanelUltra 600x600',
    category: 'İç Mekan LED',
    code: 'OKY-PU-6060',
    power: '40W / 50W',
    colorTemp: '3000K / 4000K / 6500K',
    ipRating: 'IP40',
    description: 'Ofis, hastane ve okul iç mekanları için yüksek renk doğruluk endeksli, titreşimsiz LED panel.',
    features: ['Flicker-free teknoloji', 'CRI 95+ renk doğruluğu', 'UGR < 19', 'Tunable white opsiyonu'],
    image: 'https://readdy.ai/api/search-image?query=LED%20panel%20light%20recessed%20ceiling%20office%20600x600%20flat%20slim%20modern%20design%20white%20frame%20clean%20minimalist%20product%20photography%20studio%20white%20background%20professional%20lighting%20fixture&width=600&height=500&seq=prod6&orientation=squarish',
  },
  {
    id: 7,
    name: 'SpotFocus AR111',
    category: 'Mimari Aydınlatma',
    code: 'OKY-SF-AR111',
    power: '12W / 18W / 25W',
    colorTemp: '2700K / 3000K / 4000K',
    ipRating: 'IP20',
    description: 'Mağaza, müze ve otel uygulamalarında ürün odaklı aydınlatma için yüksek CRI LED spot armatür.',
    features: ['CRI 98+ renk hassasiyeti', '10° / 24° / 38° ışın açısı', 'Tam dim 0-100%', 'Alçıpan ve ray uyumlu'],
    image: 'https://readdy.ai/api/search-image?query=adjustable%20LED%20spotlight%20track%20light%20retail%20museum%20modern%20design%20aluminum%20black%20white%20finish%20product%20photography%20studio%20clean%20background%20professional%20architectural%20lighting&width=600&height=500&seq=prod7&orientation=squarish',
    badge: 'Müze & Mağaza',
  },
  {
    id: 8,
    name: 'WallWasher ColorRGB',
    category: 'Dış Cephe Armatürleri',
    code: 'OKY-WW-RGB',
    power: '24W / 36W',
    colorTemp: 'RGB + W',
    ipRating: 'IP67',
    description: 'Bina cephelerini renklendirmek için 16 milyon renk seçeneği sunan DMX kontrollü LED wall washer.',
    features: ['16M renk paleti', 'DMX512 / RDM', 'Paslanmaz çelik vida', 'Dayanıklı akrilik mercek'],
    image: 'https://readdy.ai/api/search-image?query=LED%20wall%20washer%20RGB%20color%20architectural%20flood%20light%20outdoor%20building%20facade%20illumination%20aluminum%20housing%20modern%20design%20product%20photography%20clean%20white%20background%20professional&width=600&height=500&seq=prod8&orientation=squarish',
  },
];

export const featuredProducts: Product[] = allProducts.slice(0, 4);